import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";

/* -----------------------------------------------------------------------------
 * Checkbox wrapper for rows held for Stock Adjustment. Renders its
 * "Under Adjustment" hover label via a portal straight to <body>, because in
 * table view the checkbox often sits in a sticky column immediately followed
 * by another sticky (opaque-background) column — any CSS-only tooltip
 * painted via z-index/overflow stays trapped inside that column's own
 * stacking context and ends up hidden behind the next sticky cell. A portal
 * escapes that entirely (position: fixed, rendered outside the table).
 * ---------------------------------------------------------------------------*/
const HeldCheckbox = ({
  result,
  wrapperStyle,
  wrapperClassName,
  inputClassName,
  onChange,
  t,
  disabled,
  checked,
}) => {
  const wrapRef = useRef(null);
  const [show, setShow] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const held = !!result?.is_adjustment_held;
  const notTransferable =
    result?.isnottransferable === true ||
    result?.isnottransferable === "true";
  const transit = result?.status_type === "transit";

  const handleEnter = () => {
    if (!held) return;
    const rect = wrapRef.current?.getBoundingClientRect();
    if (rect) {
      setCoords({ top: rect.top + rect.height / 2, left: rect.right + 8 });
    }
    setShow(true);
  };

  return (
    <div
      ref={wrapRef}
      style={wrapperStyle}
      className={wrapperClassName}
      onMouseEnter={handleEnter}
      onMouseLeave={() => setShow(false)}
    >
      <input
        className={inputClassName}
        id={result?.id}
        data-id={result?.id}
        data-locationid={result?.location_id}
        warehouse_id={result?.warehouse_id}
        value={result?.id}
        data-status={result?.status_type}
        data-isnottransferable={result?.isnottransferable}
        data-isadjustmentheld={result?.is_adjustment_held}
        type="checkbox"
        checked={checked}
        disabled={
          disabled ??
          (held ||
            transit ||
            notTransferable ||
            result?.rowclass === "row-inactive")
        }
        onChange={onChange}
      />
      <label htmlFor={result?.id} className="com-check-label" />
      {show && held
        ? createPortal(
            <span
              style={{
                position: "fixed",
                top: coords.top,
                left: coords.left,
                transform: "translateY(-50%)",
                background: "#333",
                color: "#fff",
                fontSize: "11px",
                padding: "4px 8px",
                borderRadius: "4px",
                whiteSpace: "nowrap",
                zIndex: 99999,
                pointerEvents: "none",
              }}
            >
              {t("Under Adjustment")}
            </span>,
            document.body
          )
        : null}
    </div>
  );
};

export default HeldCheckbox;
